module.exports = __webpack_public_path__ + "img/ptyfbg02.d08da571.png";